import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";

export type InvestmentDomain =
	| ClientPortfolioDomainEnum.Investments
	| ClientPortfolioDomainEnum.Commodities
	| ClientPortfolioDomainEnum.Cryptocurrencies;

export const isInvestmentDomain = (
	domain: ClientPortfolioDomainEnum | null | undefined,
): domain is InvestmentDomain =>
	domain === ClientPortfolioDomainEnum.Investments ||
	domain === ClientPortfolioDomainEnum.Commodities ||
	domain === ClientPortfolioDomainEnum.Cryptocurrencies;
